import { PageHero } from "../components/common/PageHero";
import { FinalCta } from "../components/common/FinalCta";
import { Reveal } from "../components/motion/Reveal";
import { useSiteData, useC, fileUrl } from "../context/SiteData";

const Hizmetler = () => {
  const { images } = useSiteData();
  const c = useC();
  const yemekSrc = images["hizmet-yemek"] ? fileUrl(images["hizmet-yemek"]) : null;
  const sosyalSrc = images["hizmet-sosyal"] ? fileUrl(images["hizmet-sosyal"]) : null;

  return (
    <>
      <PageHero
        title={c.ph_hizmetler_title}
        subtitle={c.ph_hizmetler_subtitle}
        desc={c.ph_hizmetler_desc}
      />
      <section data-testid="hizmetler-list" className="section-y">
        <div className="container-x">
          <div className="grid gap-px border border-line bg-line sm:grid-cols-2">
            {c.services.map((s, i) => (
              <Reveal key={s.no} delay={Math.min(i * 0.05, 0.25)} className="h-full">
                <div className="group flex h-full flex-col bg-cream-50 p-7 transition-colors duration-300 hover:bg-ink-900 sm:p-9" data-testid={`hizmet-item-${s.no}`}>
                  <span className="text-xs font-bold tracking-[0.2em] text-ink-400 transition-colors duration-300 group-hover:text-cream-50/50">{s.no}</span>
                  <h2 className="mt-5 text-xl font-bold tracking-tight text-ink-900 transition-colors duration-300 group-hover:text-cream-50 sm:text-2xl">{s.title}</h2>
                  <p className="mt-3 text-sm leading-relaxed text-ink-500 transition-colors duration-300 group-hover:text-cream-50/60 sm:text-base">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-20 grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
            {yemekSrc && (
              <Reveal>
                <div className="group overflow-hidden">
                  <img src={yemekSrc} alt="Yalı Yurt yaşam alanı" loading="lazy" className="aspect-[4/3] w-full object-cover saturate-[0.92] transition-[transform,filter] duration-700 group-hover:scale-[1.02] group-hover:saturate-100" />
                </div>
              </Reveal>
            )}
            <div>
              <Reveal>
                <p className="label flex items-center gap-3 text-ink-500">
                  <span className="inline-block h-px w-8 bg-ink-400" />
                  {c.hizmet_yemek_label}
                </p>
              </Reveal>
              <Reveal delay={0.08}>
                <h2 className="mt-4 text-3xl font-bold tracking-tight text-ink-900 sm:text-4xl">
                  {c.hizmet_yemek_title}
                </h2>
              </Reveal>
              <Reveal delay={0.16}>
                <p className="mt-5 text-base leading-relaxed text-ink-500 sm:text-lg">
                  {c.hizmet_yemek_text}
                </p>
              </Reveal>
            </div>
          </div>

          {sosyalSrc && (
            <div className="mt-20">
              <Reveal>
                <div className="group relative overflow-hidden">
                  <img src={sosyalSrc} alt="Teras ve sosyal alanlar" loading="lazy" className="aspect-[16/9] w-full object-cover transition-transform duration-700 group-hover:scale-[1.02] lg:aspect-[21/9]" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink-950/70 to-transparent" />
                  <div className="absolute bottom-0 left-0 p-7 sm:p-10">
                    <p className="label text-cream-50/70">{c.hizmet_sosyal_label}</p>
                    <p className="mt-3 max-w-lg text-xl font-bold leading-snug tracking-tight text-cream-50 sm:text-2xl">
                      {c.hizmet_sosyal_text}
                    </p>
                  </div>
                </div>
              </Reveal>
            </div>
          )}
        </div>
      </section>
      <FinalCta />
    </>
  );
};

export default Hizmetler;
